import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// Routes
import { USER_SOCIAL_PROFILE } from '@/routes/apiEndpoints';

// Types
import type { SWRConfiguration } from 'swr';
import type { SocialProfileType } from '@/types/socialProfileType';

export type SocialProfileTypeWithoutAuthStatus = Omit<SocialProfileType, 'auth_status'>;

type UseSocialProfileProps = {
    SPID: SocialProfileType['id'];
    options?: SWRConfiguration<SocialProfileTypeWithoutAuthStatus, Error>;
};

const useSocialProfile = ({ SPID, options }: UseSocialProfileProps) => {
    const {
        data: socialProfile,
        mutate: mutateSocialProfile,
        error: socialProfileError,
        isLoading
    } = useSWR<SocialProfileTypeWithoutAuthStatus, Error>(
        SPID
            ? injectEndpointUrlParams(USER_SOCIAL_PROFILE, {
                  SPID: SPID
              })
            : null,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        socialProfile,
        mutateSocialProfile,
        socialProfileError,
        isLoading
    };
};
export default useSocialProfile;
